import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Stack,
    Box,
} from "@mui/material";
import SyncIcon from "@mui/icons-material/Sync";

const ModalSyncRuc = ({ open, setSyncAction, onConfirm, setLoadingSync, loadingSync }) => {

    const handleConfirm = () => {
        setLoadingSync(true);
        onConfirm();
    };

    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") return; // no cerrar
                if (!loadingSync) setSyncAction(false);
            }}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    boxShadow: "0px 8px 24px rgba(0,0,0,0.15)",
                    p: 1,
                    background:
                        "linear-gradient(180deg, #ffffff 0%, #f9fafb 100%)",
                },
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                sx={{ mt: 2 }}
            >
                <SyncIcon
                    sx={{
                        fontSize: 48,
                        color: "primary.main",
                        mb: 1,
                        animation: "spin 2s linear infinite",
                        "@keyframes spin": {
                            "0%": { transform: "rotate(0deg)" },
                            "100%": { transform: "rotate(360deg)" },
                        },
                    }}
                />

                <DialogTitle
                    sx={{
                        textAlign: "center",
                        fontWeight: 700,
                        fontSize: "1.1rem",
                        color: "text.primary",
                        mt: 1,
                    }}
                >
                    No se encontró información del proveedor.
                </DialogTitle>
            </Box>

            <DialogContent>
                <Typography
                    variant="body2"
                    align="center"
                    sx={{ color: "text.secondary", mt: 1, mb: 2 }}
                >
                    {loadingSync
                        ? "Este proceso puede tardar unos minutos. Por favor, no cierre esta ventana."
                        : "¿Desea sincronizar los datos con el SRI? Este proceso puede tardar unos minutos."}
                </Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", mb: 2 }}>
                <Stack direction="row" spacing={2} justifyContent="center">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleConfirm}
                        disabled={loadingSync}
                        sx={{
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            boxShadow: "0px 3px 8px rgba(0,0,0,0.2)",
                            "&:hover": { boxShadow: "0px 4px 10px rgba(0,0,0,0.25)" },
                        }}
                    >
                        {loadingSync ? "Sincronizando..." : "Confirmar"}
                    </Button>
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={() => setSyncAction(false)}
                        disabled={loadingSync}
                        sx={{
                            textTransform: "none",
                            borderRadius: 2,
                            px: 3,
                            "&:hover": { backgroundColor: "#f0f0f0" },
                        }}
                    >
                        Cancelar
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default ModalSyncRuc;
